"use client";

import { CourseTopicType } from "@/app/types";
import { sortArrayBySequence } from "@/app/utils/sorting";
import { useTranslations } from "next-intl";
import React, { useState } from "react";

function Topics({ topics, color = "#52a8f2",courseId }: TopicsPropsType) {
  const [opend, setOpend] = useState<number>();
  const t = useTranslations("courses");
  const title = courseId === "17" ? t("english_topics") : t("topics");

  return (
    <div style={{ background: color + "10" }}>
      <div className="container  ">
        <div className="  relative py-5 pb-10 lg:pb-60 ">
          <h6 className="text-[14px] lg:text-[1.8rem] relative w-fit m-auto font-bold mb-6 lg:text-center">
            {title}
            <span
              className="text-line end-0 !start-auto"
              style={{ backgroundColor: color }}
            ></span>
          </h6>
          <div className="flex lg:flex-row flex-col gap-[0.5rem] lg:gap-10">
            {sortArrayBySequence(topics)?.map((topic, index) => (
              <TopicCard
                topic={topic}
                key={index}
                color={color}
                index={index}
                isOpen={index == opend}
                toggleOpen={(index) =>
                  setOpend(index == opend ? undefined : index)
                }
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Topics;
type TopicsPropsType = {
  topics: CourseTopicType[];
  color?: string;
  courseId: string;
};
const TopicCard = ({
  topic,
  index,
  toggleOpen,
  color,
  isOpen,
}: TopicCardPropsType) => {
  return (
    <>
      <div
        onClick={() => toggleOpen(index)}
        style={{ borderColor: color }}
        className="group lg:w-[12.5rem] bg-white overflow-hidden cursor-pointer  relative rounded-[18px] lg:rounded-[20px] border-primary border-[2px]  lg:h-[8.75rem]  h-[30px] lg:px-[1.5rem] lg:py-[1.2rem] px-[43px] py-[6px] flex items-center"
      >
        <p className="lg:text-[1.4rem] relative z-10 line-clamp-3  lg:font-bold text-[12px]">
          {topic?.title}
        </p>
        <div
          style={{ background: isOpen ? color : color + 40 }}
          className={`absolute w-[37px] transition-all duration-300   group-hover:lg:h-[9rem] group-hover:lg:w-[9rem] text-center rounded-[23px] lg:text-start start-0 top-0 lg:rounded-none ltr:lg:rounded-br-[111px]  rtl:lg:rounded-bl-[111px] lg:start-[-1rem] lg:p-[1.5rem] lg:w-[5.4rem] lg:h-[5.4rem] z-0 lg:top-[-1.3rem] text-[20px] font-bold ${
            isOpen &&
            " !w-full !h-full !start-0 text-white !top-0 !rounded-none z-10 lg:text-[4rem] text-[20px] flex items-center justify-center"
          }`}
        >
          <p>{index}</p>
        </div>
      </div>
      <div
        style={{ borderColor: color }}
        className={`text-center bg-white w-full start-0  end-0 lg:absolute bottom-10   transition-[transform,opacity]
          duration-300 lg:py-[1.8rem] lg:px-[7.3rem] py-[12px] px-[12px] rounded-[18px] lg:rounded-[20px] border-primary border-[2px] translate-x-0 overflow-hidden ${
            !isOpen && "-translate-y-20 opacity-0  h-0 !p-0"
          }`}
      >
        <p className="lg:text-[1.75rem]  font-bold text-[12px]">
          {topic.title}
        </p>
        <p className="lg:text-[1.1rem] text-[12px] lg:line-clamp-3 line-clamp-8">
          {topic.description}
        </p>
      </div>
    </>
  );
};
type TopicCardPropsType = {
  topic: CourseTopicType;
  toggleOpen: (index: number) => void;
  index: number;
  isOpen: boolean;
  color: string;
};
